import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Minus, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { EditableText } from "@/context/ContentContext";
import { SERVICES } from "@/data/site";

export default function Servizi() {
  const [open, setOpen] = useState(null);
  return (
    <div data-testid="servizi-page" className="pt-32 md:pt-44 pb-24 md:pb-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <EditableText k="servizi_eyebrow" as="p" className="font-mono2 uppercase tracking-widest text-darkgrey mb-6" />
          <h1 className="font-heading leading-[0.95] max-w-4xl">
            <EditableText k="servizi_title1" as="span" className="inline" />{" "}
            <EditableText k="servizi_title2" as="span" className="inline" />
          </h1>
          <EditableText k="servizi_subtitle" as="p" className="font-body text-darkgrey mt-8 max-w-2xl leading-relaxed" />
        </Reveal>

        <div className="border-t border-darkgrey/40 mt-16">
          {SERVICES.map((s, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={s.n} delay={i * 0.04}>
                <div className="border-b border-darkgrey/40">
                  <button data-testid={`service-toggle-${s.n}`} onClick={() => setOpen(isOpen ? null : i)}
                    className="w-full grid grid-cols-12 gap-4 items-center py-8 text-left group">
                    <span className="col-span-2 font-mono2 text-sm text-darkgrey">{s.n}</span>
                    <span className="col-span-8 font-heading text-2xl md:text-4xl group-hover:italic transition-all">{s.title}</span>
                    <span className="col-span-2 flex justify-end text-darkgrey">{isOpen ? <Minus /> : <Plus />}</span>
                  </button>
                  {isOpen && (
                    <div className="grid grid-cols-12 gap-4 pb-10 -mt-2">
                      <p className="col-span-12 md:col-span-8 md:col-start-3 font-body text-lg text-darkgrey leading-relaxed">{s.desc}</p>
                    </div>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <div className="mt-20 flex flex-col md:flex-row md:items-center justify-between gap-6 bg-ink text-greige p-10 md:p-14">
            <p className="font-heading text-3xl md:text-4xl max-w-xl leading-tight">Parliamone direttamente. Niente form generici.</p>
            <Link to="/contatti" data-testid="servizi-cta"
              className="inline-flex items-center gap-3 bg-greige text-ink px-8 py-4 uppercase text-xs tracking-widest hover:bg-white transition-colors w-fit">
              Contattami <ArrowRight size={16} />
            </Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
